<template>
  <div id="app" @touchmove="handleTouch">
    <loading v-show="LOADING"></loading>
    <transition name="fade" mode="out-in" appear leave>
      <router-view ref="router"></router-view>
    </transition>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Loading from "@/components/Loading";
export default {
  name: "App",
  components: {
    Loading,
  },
  computed: {
    ...mapState(["LOADING"]),
  },
  created () {
    document.body.addEventListener('touchmove', (e) => {
      if (e._isScroller) return;
      e.preventDefault();
    }, {
      passive: false,
    })
  },
  methods: {
    handleTouch (e) {
      e._isScroller = true;
    }
  }
};
</script>
<style lang="less">
html {
  font-size: 50%; /*8 ÷ 16 × 100% = 50%*/
  width: 100%;
  height: 100%;
  overflow: hidden;
}
body {
  margin: 0;
  padding: 0;
  border: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
#app {
  position: fixed;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  color: #333;
  font-family: "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial,
    "PingFang SC", "Hiragino Sans GB", "Heiti SC", "WenQuanYi Micro Hei",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.van-cell {
  flex-flow: wrap !important;
  padding: 0px !important;
  margin-bottom: 20px;
  .van-field__label {
    box-sizing: border-box;
    padding: 0 2px;
    margin: 0;
    width: 100% !important;
    color: #080073;
    font-size: 14px;
    font-weight: 600;
  }
  .van-field__value {
    width: 100% !important;
    height: 50px;
    background: url("./assets/c-imgs/inputBg.png") no-repeat;
    background-size: 100% 50px;
    line-height: 50px;
    font-size: 13px;
    input {
      font-size: 13px;
      padding-left: 5vw;
      width: 90%;
    }
  }
}
.van-cell::after {
  border-bottom: none !important;
}
.submitBtn {
  width: 50%;
  margin: 50px auto;
  img {
    width: 100%;
  }
}
</style>
